import { nonnull } from '@/lib/nullish.ts';

export const isNullOrEmpty = (value: unknown) =>
  value === null || value === undefined || value === '';

export const emptyAsNull = (value: string | null | undefined) =>
  value === '' || value === undefined ? null : value;

export const nonEmptyString = (value: string | null | undefined): string => {
  return nonnull(emptyAsNull(value));
};
